__turbopack_context__.v({
  "mezzanine_video_initializer": "MezzanineVideoInitializer-module-scss-module__RvZp-W__mezzanine_video_initializer",
  "mezzanine_video_initializer_image": "MezzanineVideoInitializer-module-scss-module__RvZp-W__mezzanine_video_initializer_image",
  "mezzanine_video_initializer_placeholder": "MezzanineVideoInitializer-module-scss-module__RvZp-W__mezzanine_video_initializer_placeholder",
});
